import "./LateralHiring.scss"
import { joiResolver } from '@hookform/resolvers/joi'
import { classNames } from 'primereact/utils'
import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import { lateralHiringSchema, RECRUITMENT_FORM_FIELD_KEYS } from '../../recruitment-landing/RecruitmentLandingData'
import PrimaryButton from '../../../../components/prime-react-overrides/button/Button'
import { useVerifyEmailCollegeMutation } from '../../../../services/attendance-portal/recruitment/verification'
import toast from 'react-hot-toast'
import { setBasicDetails, selectAllData } from '../../RecruitmentDataSlice'
import { useDispatch, useSelector } from 'react-redux'
import PrimeInputText from "../../../../components/prime-react-overrides/input-text/InputText"

const LateralHiring = ({ handleOnSubmit }) => {
  const dispatch = useDispatch()
  const state = useSelector(selectAllData)
  const [verifyDetails, { isLoading: loading }] = useVerifyEmailCollegeMutation()


  const { control, formState: { errors }, handleSubmit } = useForm({
    resolver: joiResolver(lateralHiringSchema),
    defaultValues: {
      [RECRUITMENT_FORM_FIELD_KEYS.EMAIL]: ''
    }
  })
  async function handleFormSubmit(e) {


    const response = await verifyDetails({ "email": e.email }).unwrap()
    if (response.emailSent) toast.success(response.message)
    dispatch(setBasicDetails({ ...state, personalEmail: e.email }))
    handleOnSubmit()

  }


  return (
    <div className='LateralHiring '>
      <form noValidate onSubmit={handleSubmit(handleFormSubmit)}>
        <div className="p-fluid field relative">
          <Controller name={RECRUITMENT_FORM_FIELD_KEYS.EMAIL} control={control} render={({ field, fieldState }) => (
            <PrimeInputText id={field[RECRUITMENT_FORM_FIELD_KEYS.EMAIL]}
              {...field} className={classNames({ 'p-invalid': fieldState.error }, 'EmailField p-inputtext-lg')}
              placeholder="Email Address*" />
          )} />
          <small className='p-error font-medium absolute left-0 ErrorField' >{errors[RECRUITMENT_FORM_FIELD_KEYS.EMAIL] && errors[RECRUITMENT_FORM_FIELD_KEYS.EMAIL].message}</small>
        </div>
        <div className="flex justify-content-center mt-5 ">
          <PrimaryButton label="GET STARTED" type="submit" loading={loading} />
        </div>
      </form>
    </div>
  )
}

export default LateralHiring